(() => {
  'use strict';
  const root = document.documentElement;
  root.classList.remove('no-js');
  root.classList.add('js');

  const routesNode = document.querySelector('#PuntoPeludoRoutes');
  let routes = {};
  try { routes = routesNode ? JSON.parse(routesNode.textContent) : {}; } catch (error) { console.warn('Rutas de cesta no disponibles', error); }
  const currency = routes.currency || 'EUR';
  const formatMoney = (cents) => new Intl.NumberFormat(root.lang || 'es-ES', { style: 'currency', currency }).format(Number(cents || 0) / 100);
  const escapeHtml = (value = '') => { const node = document.createElement('div'); node.textContent = value; return node.innerHTML; };
  const focusableSelector = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const drawer = document.querySelector('#cart-drawer');
  const cartStatus = drawer?.querySelector('[data-cart-status]');
  const cartPageRecommendationsHost = document.querySelector('[data-cart-page-recommendations-host]');
  const recommendationsHost = cartPageRecommendationsHost || drawer?.querySelector('[data-cart-recommendations-host]');
  let cartOpener = null;
  let cartBusy = false;
  let recommendationsKey = '';
  let recommendationsLoadedKey = '';
  let recommendationsRequest = 0;
  let recommendationsController = null;
  async function requestCart(url, options = {}) {
    const response = await fetch(url, { ...options, headers: { Accept: 'application/json', ...options.headers } });
    const body = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(body.description || 'No hemos podido actualizar la cesta. Inténtalo de nuevo.');
    return body;
  }
  const getCart = () => requestCart(routes.cartJson);
  function renderShipping(cart) {
    const wrap = drawer?.querySelector('[data-shipping-progress]');
    if (!wrap) return;
    const threshold = Number(wrap.dataset.threshold || 0);
    const remaining = Math.max(threshold - cart.total_price, 0);
    const percent = threshold ? Math.min((cart.total_price / threshold) * 100, 100) : 0;
    wrap.querySelector('[data-shipping-bar]')?.style.setProperty('--progress', `${percent}%`);
    const message = wrap.querySelector('[data-shipping-message]');
    if (message) message.textContent = remaining > 0 ? `Te faltan ${formatMoney(remaining)} para el envío gratuito.` : 'Ya tienes envío gratuito.';
  }
  async function renderCartRecommendations(cart) {
    if (!recommendationsHost || !routes.recommendations) return;
    const productIds = [...new Set(cart.items.map((item) => item.product_id))];
    const nextKey = productIds.slice().sort((a, b) => Number(a) - Number(b)).join(',');
    if (!nextKey) {
      recommendationsRequest += 1;
      recommendationsController?.abort();
      recommendationsKey = '';
      recommendationsLoadedKey = '';
      recommendationsHost.hidden = true;
      recommendationsHost.dataset.state = 'empty-cart';
      recommendationsHost.removeAttribute('aria-busy');
      recommendationsHost.replaceChildren();
      return;
    }
    if (nextKey === recommendationsLoadedKey) return;
    if (nextKey === recommendationsKey && recommendationsHost.dataset.state === 'loading') return;

    recommendationsKey = nextKey;
    const requestId = ++recommendationsRequest;
    recommendationsController?.abort();
    recommendationsController = new AbortController();
    recommendationsHost.dataset.state = 'loading';
    recommendationsHost.setAttribute('aria-busy', 'true');
    try {
      const params = new URLSearchParams({
        product_id: String(productIds[0]),
        limit: '6',
        section_id: 'cart-drawer-recommendations',
        intent: 'related'
      });
      const response = await fetch(`${routes.recommendations}?${params}`, { headers: { Accept: 'text/html' }, signal: recommendationsController.signal });
      if (!response.ok) throw new Error('No se han podido cargar las recomendaciones.');
      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const recommendations = documentFragment.querySelector('[data-cart-recommendations]');
      if (requestId !== recommendationsRequest || nextKey !== recommendationsKey) return;
      const hasRecommendations = Boolean(recommendations?.querySelector('.drawer-recommendation'));
      recommendationsHost.replaceChildren();
      if (hasRecommendations) {
        recommendations.hidden = false;
        if (cartPageRecommendationsHost) recommendations.open = true;
        recommendationsHost.append(recommendations);
      }
      recommendationsHost.hidden = !hasRecommendations;
      recommendationsHost.dataset.state = hasRecommendations ? 'ready' : 'empty';
      recommendationsLoadedKey = nextKey;
    } catch (error) {
      if (error.name !== 'AbortError' && requestId === recommendationsRequest) {
        recommendationsHost.hidden = true;
        recommendationsHost.dataset.state = 'error';
        recommendationsHost.replaceChildren();
      }
    } finally {
      if (requestId === recommendationsRequest) recommendationsHost.removeAttribute('aria-busy');
    }
  }
  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.textContent = cart.item_count;
      if (node.classList.contains('drawer-count')) node.setAttribute('aria-label', `${cart.item_count} ${cart.item_count === 1 ? 'artículo' : 'artículos'} en la cesta`);
    });
    const items = drawer?.querySelector('[data-drawer-items]');
    if (!items) return;
    items.innerHTML = cart.items.length ? cart.items.map((item, index) => {
      const title = escapeHtml(item.product_title);
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="drawer-variant">${escapeHtml(item.variant_title)}</p>` : '';
      return `<article class="drawer-item"><a class="drawer-item-image" href="${item.url}">${item.image ? `<img src="${item.image}" width="208" height="208" alt="${title}" loading="lazy">` : ''}</a><div class="drawer-item-copy"><div class="drawer-item-heading"><h3><a href="${item.url}">${title}</a></h3>${variant}</div><div class="drawer-item-meta"><p class="drawer-item-price">${formatMoney(item.final_price)}</p><div class="quantity-control" aria-label="Cantidad de ${title}"><button type="button" data-line-quantity="${index + 1}" data-quantity="${Math.max(item.quantity - 1, 0)}" aria-label="Restar uno">−</button><span aria-live="polite">${item.quantity}</span><button type="button" data-line-quantity="${index + 1}" data-quantity="${item.quantity + 1}" aria-label="Añadir uno">+</button></div><button class="remove-item" type="button" data-line-quantity="${index + 1}" data-quantity="0" aria-label="Eliminar ${title}">Eliminar</button></div></div></article>`;
    }).join('') : '<div class="empty-state"><p>Tu cesta está vacía.</p><button class="text-button" type="button" data-close-cart>Seguir comprando</button></div>';
    items.removeAttribute('aria-busy');
    const total = drawer.querySelector('[data-drawer-total]');
    if (total) total.textContent = formatMoney(cart.total_price);
    const hasItems = cart.items.length > 0;
    const drawerActions = drawer.querySelector('[data-drawer-actions]');
    const drawerContinue = drawer.querySelector('[data-drawer-continue]');
    const drawerFoot = drawer.querySelector('[data-drawer-foot]');
    const drawerItemsLabel = drawer.querySelector('[data-drawer-items-label]');
    if (drawerActions) drawerActions.hidden = !hasItems;
    if (drawerContinue) drawerContinue.hidden = !hasItems;
    if (drawerFoot) drawerFoot.hidden = !hasItems;
    if (drawerItemsLabel) drawerItemsLabel.hidden = !hasItems;
    renderShipping(cart);
    renderCartRecommendations(cart);
  }
  async function refreshCart() {
    const items = drawer?.querySelector('[data-drawer-items]');
    if (items) {
      items.setAttribute('aria-busy', 'true');
      items.innerHTML = `<p>${escapeHtml(routes.cartLoading)}</p>`;
    }
    try { renderCart(await getCart()); } catch (error) {
      if (items) {
        items.removeAttribute('aria-busy');
        items.innerHTML = `<p>${escapeHtml(routes.cartLoadError)}</p>`;
      }
      if (cartStatus) cartStatus.textContent = error.message;
    }
  }
  if (cartPageRecommendationsHost) getCart().then(renderCartRecommendations).catch(() => {});
  function openCart(event) {
    closeMenu(false);
    cartOpener = event?.currentTarget || document.activeElement;
    refreshCart();
    if (drawer && !drawer.open) drawer.showModal();
    document.body.classList.add('dialog-open');
  }
  function closeCart() {
    if (drawer?.open) drawer.close();
    document.body.classList.remove('dialog-open');
    if (cartOpener instanceof HTMLElement) cartOpener.focus();
  }
  async function changeLine(line, quantity, button) {
    if (cartBusy) return;
    cartBusy = true;
    drawer?.setAttribute('aria-busy', 'true');
    button.disabled = true;
    try {
      const cart = await requestCart(routes.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity }) });
      renderCart(cart);
      if (cartStatus) cartStatus.textContent = quantity === 0 ? 'Producto eliminado de la cesta.' : 'Cantidad actualizada.';
    } catch (error) { if (cartStatus) cartStatus.textContent = error.message; button.disabled = false; }
    finally { cartBusy = false; drawer?.removeAttribute('aria-busy'); }
  }

  const menu = document.querySelector('[data-mobile-menu]');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  function setMenu(open, moveFocus = false) {
    if (!menu || !menuToggle) return;
    menu.dataset.open = String(open);
    menu.setAttribute('aria-hidden', String(!open));
    menu.inert = !open;
    menuToggle.setAttribute('aria-expanded', String(open));
    const label = menuToggle.querySelector('[data-menu-label]');
    if (label) label.textContent = open ? 'Cerrar' : 'Menú';
    document.body.classList.toggle('menu-open', open);
    if (open && moveFocus) menu.querySelector(focusableSelector)?.focus();
  }
  function closeMenu(returnFocus = true) { if (menu?.dataset.open === 'true') { setMenu(false); if (returnFocus) menuToggle?.focus(); } }
  if (menu) menu.inert = menu.dataset.open !== 'true';
  menuToggle?.addEventListener('click', () => setMenu(menu.dataset.open !== 'true', menu.dataset.open !== 'true'));
  menu?.addEventListener('click', (event) => { if (event.target.closest('[data-menu-close]')) closeMenu(); else if (event.target.closest('a')) closeMenu(false); });
  document.querySelectorAll('.nav-disclosure').forEach((details) => details.addEventListener('toggle', () => { if (details.open) document.querySelectorAll('.nav-disclosure[open]').forEach((other) => { if (other !== details) other.open = false; }); }));
  document.addEventListener('click', (event) => { if (!event.target.closest('.nav-disclosure')) document.querySelectorAll('.nav-disclosure[open]').forEach((details) => { details.open = false; }); });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') { if (menu?.dataset.open === 'true') closeMenu(); document.querySelectorAll('.nav-disclosure[open]').forEach((details) => { details.open = false; }); }
    if (event.key === 'Tab' && menu?.dataset.open === 'true') {
      const focusables = [...menu.querySelectorAll(focusableSelector)].filter((element) => element.offsetParent !== null);
      if (!focusables.length) return;
      const first = focusables[0], last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
  window.addEventListener('resize', () => { if (window.innerWidth > 1024) closeMenu(false); }, { passive: true });

  const filterPanel = document.querySelector('[data-filter-panel]');
  const filterTrigger = document.querySelector('[data-open-filters]');
  const filterClosers = document.querySelectorAll('[data-close-filters]');
  function setFilters(open) {
    if (!filterPanel || !filterTrigger) return;
    filterPanel.classList.toggle('is-open', open);
    filterTrigger.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('filters-open', open);
    if (open) filterPanel.querySelector(focusableSelector)?.focus();
    else filterTrigger.focus();
  }
  filterTrigger?.addEventListener('click', () => setFilters(true));
  filterClosers.forEach((button) => button.addEventListener('click', () => setFilters(false)));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && filterPanel?.classList.contains('is-open')) setFilters(false);
    if (event.key === 'Tab' && filterPanel?.classList.contains('is-open')) {
      const focusables = [...filterPanel.querySelectorAll(focusableSelector)].filter((element) => element.offsetParent !== null);
      if (!focusables.length) return;
      const first = focusables[0], last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
  window.addEventListener('resize', () => { if (window.innerWidth > 1024 && filterPanel?.classList.contains('is-open')) setFilters(false); }, { passive: true });

  document.querySelectorAll('[data-carousel-section]').forEach((section) => {
    const track = section.querySelector('[data-carousel]');
    const previous = section.querySelector('[data-carousel-prev]');
    const next = section.querySelector('[data-carousel-next]');
    if (!track) return;
    const move = (direction) => track.scrollBy({ left: direction * Math.max(track.clientWidth * .82, 240), behavior: reduceMotion ? 'auto' : 'smooth' });
    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const stage = gallery.querySelector('[data-gallery-stage]');
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    if (!stage || slides.length < 2 || !thumbs.length) return;

    const setActive = (index) => {
      thumbs.forEach((thumb, thumbIndex) => {
        const active = thumbIndex === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-selected', String(active));
      });
      thumbs[index]?.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
    };
    const showSlide = (index) => {
      const safeIndex = Math.max(0, Math.min(index, slides.length - 1));
      stage.scrollTo({ left: safeIndex * stage.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
      setActive(safeIndex);
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => showSlide(index));
      thumb.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
        event.preventDefault();
        const nextIndex = ['ArrowRight', 'ArrowDown'].includes(event.key) ? Math.min(index + 1, thumbs.length - 1) : Math.max(index - 1, 0);
        thumbs[nextIndex].focus();
        showSlide(nextIndex);
      });
    });

    let galleryFrame = 0;
    stage.addEventListener('scroll', () => {
      cancelAnimationFrame(galleryFrame);
      galleryFrame = requestAnimationFrame(() => {
        const index = Math.round(stage.scrollLeft / Math.max(stage.clientWidth, 1));
        setActive(Math.max(0, Math.min(index, slides.length - 1)));
      });
    }, { passive: true });
  });

  document.querySelectorAll('[data-open-cart]').forEach((button) => button.addEventListener('click', openCart));
  document.querySelectorAll('[data-close-cart]').forEach((button) => button.addEventListener('click', closeCart));
  drawer?.addEventListener('click', (event) => {
    if (event.target === drawer) { closeCart(); return; }
    const button = event.target.closest('[data-line-quantity]');
    if (button) changeLine(Number(button.dataset.lineQuantity), Number(button.dataset.quantity), button);
    if (event.target.closest('[data-close-cart]')) closeCart();
  });
  drawer?.addEventListener('close', () => document.body.classList.remove('dialog-open'));

  const pendingCartPageUpdates = new Map();
  let cartPageUpdateTimer = 0;
  let cartPageUpdating = false;
  async function updateCartPage(form) {
    if (cartPageUpdating || !pendingCartPageUpdates.size) return;
    if (!routes.cartUpdate) { form.requestSubmit(); return; }
    cartPageUpdating = true;
    window.clearTimeout(cartPageUpdateTimer);
    const status = form.querySelector('[data-cart-page-status]');
    const controls = [...form.querySelectorAll('[data-cart-quantity-adjust]')];
    form.setAttribute('aria-busy', 'true');
    controls.forEach((control) => { control.disabled = true; });
    if (status) status.textContent = form.dataset.cartUpdating || 'Actualizando cesta…';
    try {
      const updates = Object.fromEntries(pendingCartPageUpdates);
      pendingCartPageUpdates.clear();
      await requestCart(routes.cartUpdate, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
      if (status) status.textContent = form.dataset.cartUpdated || 'Cesta actualizada.';
      window.location.reload();
    } catch (error) {
      if (status) status.textContent = form.dataset.cartUpdateError || error.message;
      controls.forEach((control) => { control.disabled = false; });
      form.classList.remove('cart-auto-update-enabled');
      cartPageUpdating = false;
      form.removeAttribute('aria-busy');
    }
  }

  document.querySelectorAll('[data-cart-page-form]').forEach((form) => form.classList.add('cart-auto-update-enabled'));

  document.querySelectorAll('[data-cart-page-form] input[name="updates[]"]').forEach((input) => input.addEventListener('change', () => {
    const form = input.closest('[data-cart-page-form]');
    const lineKey = input.closest('[data-cart-line-key]')?.dataset.cartLineKey;
    if (!form || !lineKey) return;
    const quantity = Math.max(Number(input.min || 0), Number(input.value || 0));
    input.value = String(quantity);
    pendingCartPageUpdates.set(lineKey, quantity);
    const status = form.querySelector('[data-cart-page-status]');
    if (status) status.textContent = form.dataset.cartUpdating || 'Actualizando cesta…';
    window.clearTimeout(cartPageUpdateTimer);
    cartPageUpdateTimer = window.setTimeout(() => updateCartPage(form), 350);
  }));

  document.querySelectorAll('[data-cart-quantity-adjust]').forEach((button) => button.addEventListener('click', () => {
    const control = button.closest('.quantity-control');
    const input = control?.querySelector('input[name="updates[]"]');
    if (!input) return;
    const minimum = Number(input.min || 0);
    input.value = String(Math.max(minimum, Number(input.value || 0) + Number(button.dataset.cartQuantityAdjust || 0)));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }));

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const status = form.querySelector('[data-add-status]');
    const label = button?.querySelector('[data-button-label]');
    const initialLabel = label?.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    form.classList.remove('is-added', 'has-error');
    try {
      await requestCart(routes.cartAdd, { method: 'POST', body: new FormData(form) });
      if (cartPageRecommendationsHost) {
        window.location.reload();
        return;
      }
      if (status) status.textContent = 'Añadido a la cesta.';
      form.classList.add('is-added');
      if (label) label.textContent = 'Añadido';
      openCart({ currentTarget: button });
    } catch (error) { if (status) status.textContent = error.message; form.classList.add('has-error'); }
    finally {
      const selected = form.querySelector('[data-variant-select]')?.selectedOptions[0];
      button.disabled = selected ? selected.dataset.available !== 'true' || Number(selected.dataset.price) <= 0 : false;
      button.removeAttribute('aria-busy');
      if (label && initialLabel) window.setTimeout(() => { label.textContent = initialLabel; form.classList.remove('is-added'); }, 1400);
    }
  });
  document.querySelectorAll('[data-variant-select]').forEach((select) => select.addEventListener('change', () => {
    const scope = select.closest('[data-section-id]') || document;
    const option = select.selectedOptions[0];
    const available = option.dataset.available === 'true' && Number(option.dataset.price) > 0;
    const button = select.form?.querySelector('[type="submit"]');
    if (button) {
      button.disabled = !available;
      const label = button.querySelector('[data-button-label]');
      const unavailableLabel = Number(option.dataset.price) <= 0 ? option.dataset.comingSoonLabel : option.dataset.soldOutLabel;
      if (label) label.textContent = available ? option.dataset.addLabel : unavailableLabel;
      else button.textContent = available ? option.dataset.addLabel : unavailableLabel;
    }
    scope.querySelectorAll('[data-current-price]').forEach((price) => { price.textContent = Number(option.dataset.price) > 0 ? formatMoney(Number(option.dataset.price)) : option.dataset.comingSoonLabel; });
    document.querySelectorAll(`[data-sticky-price="${scope.dataset.sectionId}"]`).forEach((price) => { price.textContent = Number(option.dataset.price) > 0 ? formatMoney(Number(option.dataset.price)) : option.dataset.comingSoonLabel; });
    const comparePrice = Number(option.dataset.compareAt || 0);
    const compareNode = scope.querySelector('[data-compare-price]');
    const saleBadge = scope.querySelector('[data-product-sale]');
    const onSale = Number(option.dataset.price) > 0 && comparePrice > Number(option.dataset.price);
    if (compareNode) {
      compareNode.textContent = onSale ? formatMoney(comparePrice) : '';
      compareNode.hidden = !onSale;
    }
    if (saleBadge) {
      saleBadge.textContent = onSale ? 'Oferta' : '';
      saleBadge.hidden = !onSale;
    }
    document.querySelectorAll(`[data-sticky-compare-price="${scope.dataset.sectionId}"]`).forEach((node) => {
      node.textContent = onSale ? formatMoney(comparePrice) : '';
      node.hidden = !onSale;
    });
    document.querySelectorAll(`[data-sticky-buy="${scope.dataset.sectionId}"]`).forEach((node) => {
      node.classList.toggle('is-unavailable', !available);
      if (available) node.removeAttribute('aria-disabled');
      else node.setAttribute('aria-disabled', 'true');
    });
    document.querySelectorAll(`[data-sticky-label="${scope.dataset.sectionId}"]`).forEach((node) => {
      node.textContent = available ? 'Elegir y añadir' : Number(option.dataset.price) <= 0 ? option.dataset.comingSoonLabel : option.dataset.soldOutLabel;
    });
    const variantUrl = new URL(location.href);
    variantUrl.searchParams.set('variant', select.value);
    history.replaceState({}, '', variantUrl);
  }));
  document.querySelectorAll('select[name="sort_by"][form]').forEach((select) => select.addEventListener('change', () => {
    if (select.form) select.form.requestSubmit();
  }));

  const stickyBuy = document.querySelector('.product-sticky-buy');
  const primaryProductForm = document.querySelector('.product-info .product-form');
  if (stickyBuy) stickyBuy.addEventListener('click', (event) => {
    if (stickyBuy.getAttribute('aria-disabled') === 'true') event.preventDefault();
  });
  if (stickyBuy && primaryProductForm && 'IntersectionObserver' in window) {
    const primaryObserver = new IntersectionObserver(([entry]) => {
      stickyBuy.classList.toggle('is-primary-visible', entry.isIntersecting);
    }, { threshold: .2 });
    primaryObserver.observe(primaryProductForm);
    const footer = document.querySelector('.site-footer');
    if (footer) {
      const footerObserver = new IntersectionObserver(([entry]) => {
        stickyBuy.classList.toggle('is-footer-visible', entry.isIntersecting);
      }, { threshold: .05 });
      footerObserver.observe(footer);
    }
    const productDetails = document.querySelector('.product-details-wide');
    if (productDetails) {
      const detailsObserver = new IntersectionObserver(([entry]) => {
        stickyBuy.classList.toggle('is-details-visible', entry.isIntersecting);
      }, { threshold: .01 });
      detailsObserver.observe(productDetails);
    }
    const productSummary = document.querySelector('.product-info .product-summary');
    if (productSummary) {
      const summaryObserver = new IntersectionObserver(([entry]) => {
        stickyBuy.classList.toggle('is-summary-visible', entry.isIntersecting);
      }, { threshold: .01 });
      summaryObserver.observe(productSummary);
    }
  }

  if (!reduceMotion && 'IntersectionObserver' in window) {
    const nodes = [...document.querySelectorAll('[data-motion], main .section-head, .species-card, .category-card, .product-card')];
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } }), { rootMargin: '0px 0px -5% 0px', threshold: .05 });
    nodes.forEach((node, index) => { node.dataset.motion = ''; node.style.setProperty('--motion-delay', `${Math.min(index % 4, 3) * 55}ms`); observer.observe(node); });
    root.classList.add('motion-ready');
  }
  if (!reduceMotion && document.body.classList.contains('premium-motion')) {
    let frame = 0;
    const update = () => { frame = 0; const max = Math.max(root.scrollHeight - innerHeight, 1); root.style.setProperty('--scroll-progress', Math.min(scrollY / max, 1).toFixed(4)); document.body.classList.toggle('has-scrolled', scrollY > 24); };
    addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(update); }, { passive: true });
    update();
  }
})();
